module.exports = __webpack_public_path__ + "img/gallery-pic02.e0571adb.jpg";